import styled from "styled-components";

export const BodyContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
  height: calc(100vh - 70px);
  min-height: calc(100vh - 70px);
  overflow-x: hidden;
  @media (max-width: 1279px) {
    height: calc(100vh - 70px);
    min-height: calc(100vh - 70px);
  }
  /* Let's get this party started */
  ::-webkit-scrollbar {
    width: 8px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }
  ::-webkit-scrollbar-thumb:hover {
    background: var(--color-latex10);
  }

  @media (max-width: 768px) {
    /* Let's get this party started */
    ::-webkit-scrollbar {
      width: 4px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
      -webkit-border-radius: 10px;
      border-radius: 10px;
      background: var(--color-scrollbar);
    }
    ::-webkit-scrollbar-thumb:hover {
      background: var(--color-latex10);
    }
  }
`;

export const ContainerScroll = styled.div`
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  @media (max-width: 1024px) {
    display: block;
    padding: 0;
    /* height: 100%; */
    height: calc(100% - 78px);
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    gap: 0;
  }
`;
